function a(e) {
  if (e) return e.charAt(0).toUpperCase() + e.slice(1);
}
function t(e) {
  if (e) return e.toLowerCase().replace(/\S+/g, r => a(r));
}
function i(e) {
  var r;
  if (e) return (r = e.trim().toLowerCase().match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) == null ? void 0 : r.join("_");
}
function n(e) {
  return e == null || e == null ? !1 : e.trim() != "";
}
export { n as a, a as c, i as s, t };